import React, {useState ,useEffect} from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SortIcon from "@mui/icons-material/Sort";
import CurrencyFormat from "react-currency-format";
import {useDispatch, useSelector} from "react-redux";
import {contentAction, productAction} from "../../actions";
import {Box} from "@mui/material";
import Button from "@mui/material/Button";

const SelectProduct = ({formData ,onchange ,state,title,list ,type}) => {
    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [form, setForm] = useState(formData);
    const [defaultList, setDefaultList] = useState(false);
    const [tags, setTags] = useState(formData);
    const [relatedItem, setRelatedItem] = useState([]);

    const [filter, setFilter] = useState({
        title: "",
    });

    const productReducer = list
    const dispatch = useDispatch()

    useEffect(() => {
        setTags(formData)
        setForm(formData)
    } ,[formData])

    useEffect(() => {
        handleRequest();
    }, [filter]);





    const handleSelected = async (item) => {
        let index = form[state]?.findIndex((findItem) => {
            return +findItem.id === +item.id
        })
        //مشکل اینجاستش
        let frm = form;
        if (index === -1) {
            frm[state] = [...form[state], item];
        } else {
            await frm[state]?.splice(index, 1)
        }

        setForm({...frm});
        onchange({...frm})
    };

    const handleDelete = async (id) => {
        let frm = form;
        let index = relatedItem?.findIndex((item) => {
            return item?.id === id
        })
        let indexed = form[state]?.findIndex((findItem) => {
            return findItem.id === id
        })
        await form[state]?.splice(indexed, 1)
        delete relatedItem[index]
        setForm({...frm});
        onchange({...frm})
    };

    const handleRequest = () => {
        if(type ===  "blog") {
            dispatch(contentAction.contents({filter: JSON.stringify(filter)}))
        } else {
            dispatch(productAction.fetchProducts({filter: filter}))
        }
    };


    const handleChangeSearchInput = (name , value ) => {
        let search = filter;
        search[name] = value;
        setFilter({...search})
    }

    const handleChecked = (id) => {
       let findItem = form[state]?.find((item) => {
            return item.id === id
        })
        if(findItem) {
            return true
        } else {
            return false
        }
    }

    return (
        <div style={{width:"100%"}}>
                <TextField
                    id="outlined-name"
                    type={"search"}
                    label={title}
                    variant="outlined"
                    margin='dense'
                    fullWidth
                    name='title'
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{endAdornment:
                            <Button style={{width:"200px" , margin:"5px"}} color='default'  variant='contained' onClick={() => {handleChangeSearchInput("title" , "") ; setDefaultList(!defaultList)}} >{defaultList ? " بستن": ( type === "blog" ? "مشاهده آخرین مقالات" : "مشاهده آخرین محصولات")}</Button>
                    }}
                    onChange={(e) =>handleChangeSearchInput(e.target.name,e.target.value)}
                    value={filter.title}
                />
                {form[state]?.map((item, index) => {
                    return (
                        (item.title ||  item.name) &&
                        <Chip
                            label={item.title ||  item.name}
                            clickable
                            color="default"
                            onDelete={() => {
                                handleDelete(item.id)
                            }}
                        />
                    )
                })}
            {
                   ( filter?.title?.length > 1 || defaultList ) &&
                    <div style={{overflowX: 'auto'}}>
                        {
                            type === "blog" ?
                                <table className='table'>
                                    <thead>
                                    <tr>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('id')
                                        }}>#&nbsp;{sort_field === 'id' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                                        <th>عنوان</th>

                                        <th>نویسنده</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {productReducer.entities.data && productReducer.entities.data.map((entity, index) => {
                                            return (
                                                <tr onClick={() => handleSelected({id:entity.id , title:entity.title})} style={{backgroundColor: (entity.count <= entity.order_point || entity.count <= 0 ? '#d7c343' : '')}}
                                                    key={index}>
                                                    <td>{entity.id}</td>
                                                    <td>{entity.title}</td>
                                                    <td>{entity.created_by?.name + " "+ entity.created_by?.family}</td>
                                                    <td>
                                                        <input checked={handleChecked(entity.id)}
                                                               type='checkbox'
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                                    </tbody>
                                </table>
                                :
                                <table className='table'>
                                    <thead>
                                    <tr>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('id')
                                        }}>#&nbsp;{sort_field === 'id' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('title')
                                        }}>نام &nbsp;{sort_field === 'title' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                                        <th>تنوع محصول</th>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('brand_id')
                                        }}>برند &nbsp;{sort_field === 'brand_id' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('package_type_id')
                                        }}>واحد&nbsp;{sort_field === 'package_type_id' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('count')
                                        }}>موجودی&nbsp;{sort_field === 'count' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('price')
                                        }}>قیمت (تومان)&nbsp;{sort_field === 'price' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                                        <th onClick={() => {
                                            setSortType(sort_type === 'asc' ? 'desc' : 'asc');
                                            setSortField('selected')
                                        }}>انتخاب&nbsp;{sort_field === 'selected' ? (sort_type === 'desc' ?
                                            <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {productReducer.entities.data && productReducer.entities.data.map((entity, index) => {
                                            return (
                                                <tr onClick={() => handleSelected({id:entity.id , title:entity.title})} style={{backgroundColor: (entity.count <= entity.order_point || entity.count <= 0 ? '#d7c343' : '')}}
                                                    key={index}>
                                                    <td>{entity.id}</td>
                                                    <td>
                                                        <b>{entity.title}<br/>{(entity.types && entity.types.length > 0 && entity.types[0].title && entity.types[0].title)}
                                                        </b></td>
                                                    <td>{entity.types && entity.types.length > 0 ? entity.types.length : 0}</td>
                                                    <td>{entity.brand ? entity.brand.title : '-'}</td>
                                                    <td>{entity.package_type ? entity.package_type.title : '-'}</td>
                                                    <td><CurrencyFormat
                                                        value={entity.types && entity.types.length > 0 && entity.types[0].count ? entity.types[0].count : 0}
                                                        displayType={'text'} thousandSeparator={true}/></td>
                                                    <td><CurrencyFormat
                                                        value={entity.types && entity.types.length > 0 && entity.types[0].price ? entity.types[0].price : 0}
                                                        displayType={'text'} thousandSeparator={true}/></td>
                                                    <td>
                                                        <input checked={handleChecked(entity.id)}
                                                               type='checkbox'
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                                    </tbody>
                                </table>
                        }

                    </div>
                }
        </div>
    );
};

export default SelectProduct;
